
(() => {
  // Only take over quantity buttons for case-pack items.
  document.addEventListener('click', (event) => {
    const button = event.target.closest(
      '.quantity-selector--plus, .quantity-selector--minus'
    );
    if (!button) return;

    const selector = button.closest('quantity-selector');
    if (!selector || selector.dataset.type !== 'cart') return;

    const step = Number(selector.dataset.step);
    if (step !== 6) return;

    // Stop the theme's normal +/- 1 behavior.
    event.preventDefault();
    event.stopImmediatePropagation();

    const input = selector.querySelector('.quantity-selector--input');
    if (!input) return;

    const current = Number(input.value) || 0;
    const isPlus = button.classList.contains('quantity-selector--plus');
    const next = isPlus ? current + 6 : current - 6;

    // Never let the case-pack quantity drop below 6.
    input.value = Math.max(6, next);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  }, true);

  
document.addEventListener('change', (event) => {
  const input = event.target;
  if (!input.matches('.quantity-selector--input')) return;

  const selector = input.closest('quantity-selector');
  if (!selector || selector.dataset.type !== 'cart') return;
  if (Number(selector.dataset.step) !== 6) return;

  const entered = Number(input.value);

  if (Number.isInteger(entered) && entered >= 6 && entered % 6 === 0) {
    return;
  }

  event.stopImmediatePropagation();

  const corrected = Math.max(6, Math.ceil((entered || 0) / 6) * 6);
  input.value = corrected;

  input.dispatchEvent(new Event('change', { bubbles: true }));
}, true);


})();
